var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-player',{ref:"camOnlinePlayer",staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.playerOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }